import Vue from 'vue';

const readable = value => {
  if (!value) {
    return '';
  }
  const words = value.split(/[-_ ]+/g);
  const results = [];
  for (let i = 0; i < words.length; i++) {
    const letter = words[i].charAt(0).toUpperCase();
    results.push(letter + words[i].slice(1));
  }
  return results.join(' ');
};
export default readable;

Vue.filter('readable', readable);
